import { connect } from 'react-redux';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Route, Switch, withRouter} from 'react-router-dom';
import Login from './Login';
import Logout from './Logout';
import GlobalError from '../../app/components/GlobalError';
import Register from './Register';
import {NoMatch} from "../../app/containers/NoMatch";
import Helmet from "react-helmet";
import {injectIntl, intlShape} from "react-intl";

@injectIntl
export class Auth extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        intl: intlShape,
    }

    render() {
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.signup' })} />
                <Page.Header />
                <GlobalError />
                <Switch>
                    <Route exact path='/auth/login' redirectRoute='/' component={Login} />
                    <Route exact path='/auth/logout' component={Logout} />
                    <Route exact path='/auth/register' component={Register} />
                    <Route component={NoMatch}/>
                </Switch>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(() => ({}))(Auth));
